import { LoaderFunction } from "react-router-dom";
import usePromiseFetcher from "../../../../common/core-ui/usePromiseFetcher.ts";
import {
  ContentAccess,
  getContentAccess,
} from "../../../../common/api/decimal/methods/course.ts";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";

export const contentAccessAction: LoaderFunction = async ({
  request,
}): Promise<unknown> => {
  const formData = await request.formData();
  const path = formData.get("path") as string;
  if (path) {
    return getContentAccess(path);
  }
  return null;
};

export function useContentAccessFetcher() {
  return usePromiseFetcher<DecimalResult<ContentAccess>>();
}
